import {SPECS as SdkSpecs} from '@wix/wixstores-client-storefront-sdk/dist/es/src/constants';

export const SPECS = {
  ...SdkSpecs,
  SUBSCRIPTION_PLAN_USE_TPA_RADIO_BUTTON: 'specs.stores.SubscriptionPlanUseTpaRadioButton',
  USE_LIGHTBOXES: 'specs.stores.UseLightboxes',
  EDITOR_OOI: 'specs.stores.EditorGalleryOOI',
  DISABLE_MOBILE_NATIVE_DROPDOWN: 'specs.stores.DisableMobileNativeDropdown',
  FIX_CASHIER_PROPS_PRICE_SHIFTING: 'specs.stores.ProductPageFixCashierPropsPriceShifting',
  LOCATION_ONCHANGE_PATH_CHANGE_FOR_EDITOR_SAUSAGE:
    'specs.stores.ProductPageLocationOnChangePathChangeForEditorSausage',
  PRODUCT_PAGE_MIGRATE_TO_RICO_DESCRIPTION: 'specs.stores.ProductPageMigrateToRicoDescription',
  PRODUCT_PAGE_SLOTS: 'specs.stores.ProductPageSlots',
  PRODUCT_PAGE_NEW_WIX_CODE_API: 'specs.stores.ProductPageNewWixCodeApi',
  EnableDynamicSizeDefaultImage: 'specs.stores.EnableDynamicSizeDefaultImage',
  SendSubcategoriesSeoDataSF: 'specs.stores.SendSubcategoriesSeoDataSF',
  MainMediaWrapperAsAnchorElement: 'specs.stores.MainMediaWrapperAsAnchorElement',
  ProductPageSlotsAddMoreProps: 'specs.stores.ProductPageSlotsAddMoreProps',
  ProductPageUpliftProductOptionsViewer: 'specs.stores.ProductPageUpliftProductOptionsViewer',
  SubscriptionPlansNewDesignViewer: 'specs.stores.SubscriptionPlansNewDesignViewer',
  ProductPageSupportGridLayout: 'specs.stores.ProductPageSupportGridLayout',
  InfoSectionTabsTPAComponent: 'specs.stores.InfoSectionTabsTPAComponent',
  LoadClientConfigInController: 'specs.stores.LoadClientConfigInController',
  AllowProductPageButtonsOption: 'specs.stores.allowProductPageButtonsOption',
  GalleryOptionButtonsGrid: 'specs.stores.GalleryOptionButtonsGrid',
  ProductPageSsrInvalidationTags: 'specs.stores.ProductPageSsrInvalidationTags',
  ProductMediaNavigationDots: 'specs.stores.ProductMediaNavigationDots',
  ResponsiveGalleryMigration: 'specs.stores.ResponsiveGalleryMigration',
  ProductPageFixReflowSausageNavigation: 'specs.stores.ProductPageFixReflowSausageNavigation',
  MediaSlotOnBottomForResponsiveGallery: 'specs.stores.ResponsiveLayoutMediaSlotBottom',
  ReturnCartIdNullInsteadOfDeprecatedForExpressService:
    'specs.stores.ReturnCartIdNullInsteadOfDeprecatedForExpressService',
  ProductPageConsumePublicDataFromBothScopes: 'specs.stores.ProductPageConsumePublicDataFromBothScopes',
  FixVariantIdCalculationInBuyNowFlow: 'specs.stores.FixVariantIdCalculationInBuyNowFlow',
  UseExperimentsFromPlatformFlowApi: 'specs.stores.UseExperimentsFromPlatformFlowApi',
  SwitchMainMediaSlickToSwiper: 'specs.stores.SwitchMainMediaSlickToSwiper',
  ProductPageRemovePagination: 'specs.stores.ProductPageRemovePagination',
  ImageSettingsInViewer: 'specs.stores.ImageSettingsInViewer',
  ProductNameHtmlTag: 'specs.stores.ProductNameHtmlTag',
  ResponsiveEditorBreadcrumbsToggle: 'specs.stores.ResponsiveEditorBreadcrumbsToggle',
  FixQuickViewNavigationToProductPage: 'specs.stores.FixQuickViewNavigationToProductPage',
  ThumbnailsDesignViewer: 'specs.stores.ThumbnailsDesignViewer',
  ProductPageWaitForWarmupData: 'specs.stores.ProductPageWaitForWarmupData',
  ProductPageVideoPosterOptimization: 'specs.stores.ProductPageVideoPosterOptimization',
  FixVerticalThumbnailsPosition: 'specs.stores.FixVerticalThumbnailsPosition',
  StickyAddToCartMobile: 'specs.stores.StickyAddToCartMobile',
  FixProductPageDropdownMobileSsr: 'specs.stores.FixProductPageDropdownMobileSsr',
  ProductPageBreadcrumbsDesignViewer: 'specs.stores.ProductPageBreadcrumbsDesignViewer',
  CheckoutPagePreviewEnabled: 'specs.stores.CheckoutPagePreviewEnabled',
  AddDiscountsToVariantsItemsQueriesPPOOI: 'specs.stores.AddDiscountsToVariantsItemsQueriesPPOOI',
  ShowUserWishlistStateInProductPage: 'specs.stores.ShowUserWishlistStateInProductPage',
};
